export const MODULE_KEYS = {
  socialMonitoring: 'socialMonitoring',
  gkp: 'globalKolPlanning',
  insights: 'insights',
  sosvExperts: 'sosvExperts',
  sosvScience: 'sosvScience',
  customReports: 'customReports',
  insightsCapture: 'insightsCapture',
};
